{
    "required": "هذا الحقل مطلوب.",
    "email": "أدخل بريداً إلكترونياً صحيحاً.",
    "min_length": "يجب ألا يقل عن {{count}} حرفاً.",
    "max_length": "يجب ألا يزيد عن {{count}} حرفاً.",
    "phone_om": "أدخل رقماً عمانياً صحيحاً، مثال ‎+968 9123 4567‎.",
    "civil_id": "الرقم المدني مكوّن من 8 أرقام.",
    "passwords_match": "كلمتا المرور غير متطابقتين.",
    "invalid_colour": "أدخل لوناً ست عشرياً مثل ‎#0B2A4A‎.",
    "file_too_large": "حجم الملف يتجاوز الحد {{max}}.",
    "file_type": "نوع الملف غير مقبول."
}
